import { useState } from "react";
import { Loader2, Mail } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", role: "buyer", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      setDone(true);
      toast.success("Message sent! We'll be in touch.");
      setForm({ name: "", email: "", role: "buyer", subject: "", message: "" });
    } catch {
      toast.error("Could not send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-2 gap-12">
      <div>
        <p className="overline mb-3">Get in touch</p>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-5">
          Buyer or seller?<br />We're here to help.
        </h1>
        <p className="text-muted-foreground mb-8 leading-relaxed">
          Questions about an order, shipping across NZ & AU, GST, or want to sell your products
          through Go Big Forever? Send us a message — or use the live AI concierge in the corner for instant answers.
        </p>
        <div className="flex items-center gap-3 text-sm">
          <Mail className="text-brand" size={20} />
          <span>support@gobig.store</span>
        </div>
      </div>

      <form onSubmit={submit} className="border border-ink p-6 space-y-4">
        <div className="flex gap-2">
          {["buyer", "seller"].map((r) => (
            <button
              key={r}
              type="button"
              onClick={() => setForm({ ...form, role: r })}
              data-testid={`contact-role-${r}`}
              className={`flex-1 py-2 text-sm font-bold uppercase border transition-colors ${form.role === r ? "bg-ink text-white border-ink" : "border-ink/20 hover:border-ink"}`}
            >
              I'm a {r}
            </button>
          ))}
        </div>
        <input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="contact-name" className="w-full border-b border-ink/30 focus:border-brand outline-none bg-transparent py-2" />
        <input type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="contact-email" className="w-full border-b border-ink/30 focus:border-brand outline-none bg-transparent py-2" />
        <input placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" className="w-full border-b border-ink/30 focus:border-brand outline-none bg-transparent py-2" />
        <textarea placeholder="How can we help?" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required rows={4} data-testid="contact-message" className="w-full border border-ink/20 focus:border-brand outline-none bg-transparent p-3" />
        <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="contact-submit">
          {loading ? <Loader2 size={18} className="animate-spin" /> : "Send message"}
        </button>
        {done && <p className="text-green-600 text-sm text-center" data-testid="contact-success">Thanks! Our team will reply shortly.</p>}
      </form>
    </div>
  );
}
